import Vue from 'vue';
import Vuex from 'vuex';

import appConfig from './app/appConfig.module';
import kit from './app/kit.module';
import translate from './app/translate.module';

import region from './shared/region.module';

import period from './periodical/period.module';
import periodSourceData from './periodical/periodSourceData.module';
import periodicalResult from './periodical/periodicalResult.module';

import hgFarmerSourceData from './hg-farmer/hgFarmerSourceData.module';
import hgFarmerResult from './hg-farmer/hgFarmerResult.module';

import geneticSimilarities from './genetic-similarities/geneticSimilarities.module';
import ancientProxSourceData from './genetic-similarities/single/ancientProxSourceData.module';
import ancientProxResult from './genetic-similarities/single/ancientProxResult.module';
import ancientProxSampleCoordinate from './genetic-similarities/single/ancientProxSampleCoordinate.module';
import ancientNotableIndividualResult from './genetic-similarities/single/ancientNotableIndividualResult.module';

import mixedModePeriod from './genetic-similarities/mixed-mode/mixedModePeriod.module';
import mixedModeResult from './genetic-similarities/mixed-mode/mixedModeResult.module';

import pcaRegion from './pca-plots/pcaRegion.module';
import pcaSourceData from './pca-plots/pcaSourceData.module';

import sampleDatabase from './sample-database/sampleDatabase.module';
import ancientDatabase from './sample-database/ancientDatabase.module';
import ancientIndividualDatabase from './sample-database/ancientIndividualDatabase.module';
import modernDatabase from './sample-database/modernDatabase.module';

import modernSourceData from './modern/modernSourceData.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    appConfig,
    kit,
    translate,
    
    // Shared
    region,

    // Periodical
    period,
    periodSourceData,
    periodicalResult,

    // Hg Farmer
    hgFarmerSourceData,
    hgFarmerResult,

    // Genetic Similarities
    geneticSimilarities,
    ancientProxSourceData,
    ancientProxResult,
    ancientProxSampleCoordinate,
    ancientNotableIndividualResult,
    
    mixedModePeriod,
    mixedModeResult,

    pcaRegion,
    pcaSourceData,

    sampleDatabase,
    ancientDatabase,
    ancientIndividualDatabase,
    modernDatabase,

    modernSourceData,
  },
  strict: process.env.DEV,
})
